import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import { WobbleUpdater } from "./WobbleUpdater";
export function loadWobbleUpdater(engine) {
  return _regeneratorRuntime.async(function loadWobbleUpdater$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(engine.addParticleUpdater("wobble", function (container) {
            return new WobbleUpdater(container);
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  });
}